module.exports = __webpack_public_path__ + "static/media/39.60e42f25.png";